import { Component, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { AnalyticsService } from '@promojds-front/analytics';
import { HlmToasterComponent } from '@spartan-ng/helm/sonner';
import { tap } from 'rxjs';

@Component({
  standalone: true,
  imports: [RouterModule, HlmToasterComponent],
  selector: 'pj-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  public inMaintenanceMode = signal(false);

  title = 'Promo jds - la centrale de toutes les promotions sur les jeux de société';

  constructor(
    private titleService: Title,
    private ccService: NgcCookieConsentService,
    private analyticsService: AnalyticsService
  ) {
  }

  public ngOnInit(): void {
    this.setTitle();
    this.shouldCookieBeHidden();
  }

  private setTitle(): void {
    this.titleService.setTitle(this.title);
  }

  private shouldCookieBeHidden(): void {
    if (this.ccService.hasAnswered()) {
      const revokeEl = document.querySelector<HTMLElement>('.cc-revoke');
      revokeEl?.style.setProperty('display', 'none', 'important');
    }
    this.ccService.statusChange$.pipe(
      tap(() => {
        this.hideCookiePopup();
      })).subscribe();
  }

  private hideCookiePopup(): void {
    const revokeEl = document.querySelector<HTMLElement>('.cc-revoke');
    revokeEl?.style.setProperty('display', 'none', 'important');
  }
}
